<template>
  <div class="layout-box">
    <LayoutHeader headtitle="云定制"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <h2>定制项目</h2>
      </div>
      <ul class="experts-list clear">
        <li v-for="(item,index) in datas" :key="index">
          <a :href="item.url" target="_blank" :title="item.tit"><img :src="item.img" /></a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";
export default {
  name: 'IndustryCustom',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      datas:[
        {img:require('../../assets/img/custom-bg.jpg'),url:'https://forum.ccf.com.cn/fiber/dz.php',tit:'报告定制'},
        {img:require('../../assets/img/custom-rj.jpg'),url:'https://forum.ccf.com.cn/fiber/dz_rj.php',tit:'软件定制'},
        {img:require('../../assets/img/custom-zf.jpg'),url:'https://forum.ccf.com.cn/fiber/dz_zf.php',tit:'走访定制'},
        {img:require('../../assets/img/custom-hy.jpg'),url:'https://forum.ccf.com.cn/fiber/dz_hy.php',tit:'会议定制'}
      ]
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}

.secondary-content{
  width: 1100px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.experts-title h2{
  font-family: "fzskjt";
  line-height: 59px;
  color:#fff;
  font-style: oblique;
  padding-left: 20px;
}

.experts-list{
  /*padding-top: 30px;*/
  padding-bottom: 30px;
}

.experts-list li{
  /*margin: 0 20px;*/
  padding: 10px;
  width: calc(100%-20px);
  background: #E3E9F6;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.experts-list li:hover{
  background: #fff;
}

.experts-list li img{
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-industrycustom-list.vue